import { motion } from 'framer-motion'
import { BoatIndicator } from '../ui/BoatIndicator'

interface LowerThirdProps {
  title: string
  subtitle: string
  boatNumber?: number
  boatColor?: string
  highlight?: string
}

export function LowerThird({
  title,
  subtitle,
  boatNumber,
  boatColor,
  highlight,
}: LowerThirdProps) {
  return (
    <div className="fixed bottom-0 left-0 right-0 h-32 bg-transparent flex items-end pointer-events-none">
      <motion.div
        initial={{ x: -500 }}
        animate={{ x: 0 }}
        transition={{ type: 'spring', stiffness: 100 }}
        className="flex-1 h-full flex items-center gap-4 bg-gradient-to-r from-tropical-green to-paradise-blue p-1"
      >
        <div className="bg-palm-dark h-full flex items-center gap-4 px-6 flex-1">
          {boatNumber && boatColor && (
            <BoatIndicator
              boatNumber={boatNumber}
              color={boatColor}
              size="lg"
            />
          )}

          <div className="flex-1">
            <motion.h2
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.2 }}
              className="text-4xl font-fredoka font-700 text-sand-light"
            >
              {title}
            </motion.h2>

            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3 }}
              className="text-lg font-quicksand text-tropical-green"
            >
              {subtitle}
            </motion.p>
          </div>

          {highlight && (
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.4 }}
              className="px-4 py-2 bg-tropical-green text-palm-dark rounded-lg font-fredoka font-700 text-lg"
            >
              {highlight}
            </motion.div>
          )}
        </div>
      </motion.div>
    </div>
  )
}
